export const VIDEO_RESOLUTION_PRESETS = [
	{
		ratio: '16:9',
		resolutions: {
			'720p': '1280*720',
			'1K': '1792*1024',
			'1080p': '1920*1080'
		}
	},
	{
		ratio: '9:16',
		resolutions: {
			'720p': '720*1280',
			'1K': '1024*1792',
			'1080p': '1080*1920'
		}
	},
	{
		ratio: '1:1',
		resolutions: {
			'720p': '960*960',
			'1080p': '1440*1440'
		}
	},
	{
		ratio: '4:3',
		resolutions: {
			'720p': '1088*832',
			'1080p': '1632*1248'
		}
	},
	{
		ratio: '3:4',
		resolutions: {
			'720p': '832*1088',
			'1080p': '1248*1632'
		}
	}
] as const;


